var render, staticRenderFns
import script from "./SetLocation.vue?vue&type=script&lang=ts"
export * from "./SetLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96d78d",
  null
  
)

export default component.exports